var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63636 6.55196H9.45455V8.00795H3.63636V10.1919L0 7.27995L3.63636 4.36797V6.55196ZM2.90909 11.6479H4.87855C5.71832 12.3893 6.75395 12.8723 7.86118 13.0391C8.96841 13.2058 10.1002 13.0493 11.1207 12.5881C12.1413 12.127 13.0072 11.3809 13.6146 10.4393C14.222 9.49776 14.5451 8.40076 14.5451 7.27995C14.5451 6.15915 14.222 5.06215 13.6146 4.12059C13.0072 3.17903 12.1413 2.43292 11.1207 1.97177C10.1002 1.51063 8.96841 1.35405 7.86118 1.52083C6.75395 1.6876 5.71832 2.17064 4.87855 2.91198H2.90909C3.58594 2.00721 4.46424 1.27291 5.47423 0.767412C6.48423 0.261915 7.59807 -0.000847126 8.72727 2.0517e-06C12.744 2.0517e-06 16 3.25924 16 7.27995C16 11.3007 12.744 14.5599 8.72727 14.5599C7.59807 14.5608 6.48423 14.298 5.47423 13.7925C4.46424 13.287 3.58594 12.5527 2.90909 11.6479V11.6479Z",
    fill: "#2E2E2E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLight);
export default __webpack_public_path__ + "static/media/logoutLight.8a009d68ba20e34ed647e4948f684d2b.svg";
export { ForwardRef as ReactComponent };